export const UPDATE_SIGNUP_DATA = 'ADD_SIGNUP_DATA';
export const CLEAR_SIGNUP_DATA = 'CLEAR_SIGNUP_DATA';

// data persisted for display during signup flow regardless of BE return
// i.e. firstname-lastname vs firstname-last_initial

export const updateSignupData = data => ({
  type: UPDATE_SIGNUP_DATA,
  data,
});

export const clearSignupData = () => ({
  type: CLEAR_SIGNUP_DATA,
});
